<template>
    <div class="rep-chart" :style="{ height: height + 'px' }">
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import Chart from "chart.js/auto";

// Envoltorio mínimo de Chart.js: recrea la gráfica cuando cambian los datos
export default {
    name: "ReputacionChart",
    props: {
        type: { type: String, required: true },
        data: { type: Object, required: true },
        options: { type: Object, default: () => ({}) },
        height: { type: Number, default: 260 },
    },
    setup(props) {
        const canvas = ref(null);
        let chart = null;

        const render = () => {
            if (chart) chart.destroy();
            if (!canvas.value) return;
            chart = new Chart(canvas.value.getContext("2d"), {
                type: props.type,
                data: props.data,
                options: { responsive: true, maintainAspectRatio: false, ...props.options },
            });
        };

        onMounted(render);
        watch(() => [props.data, props.options, props.type], render);
        onBeforeUnmount(() => {
            if (chart) chart.destroy();
            chart = null;
        });

        return { canvas };
    },
};
</script>

<style scoped>
.rep-chart {
    position: relative;
    width: 100%;
}
</style>
